export type DATA_LAYER_CATEGORY = 'signIn' | 'core'
export type DATA_LAYER_SUBCATEGORY = 'passkey-reset' | 'liquid-treasuries' | 'card-activation' | 'profile'
export type DATA_LAYER_EVENT =
  | 'user_mobilePhoneVerifiedPasskeyReset_visit'
  | 'user_identityVerified_visit'
  | 'user_activatePhysicalCard_visit'
  | 'user_cardActivatedSuccess_visit'
  | 'user_setAPIN_visit'
  | 'user_setAPINSuccess_visit'
  | 'user_activatePhysicalCardError_visit'
  | 'user_setAPINError_visit'
  | 'user_emailVerified_visit'
  | 'user_mobilePhoneVerified_visit'
  | 'user_addressVerified_visit'
  | 'user_passkeyCreateSuccess_visit'
  | 'user_docvFraudReview_visit'
  | 'user_docvVerifyYourIdentity_visit'
  | 'user_createNewPasskey_visit'
  | 'user_applicationUnderReview_visit'

export enum CoreDataLayerEventsEnum {
  EgmSubmissionRegistrationCredentialOptionsSubmit = 'egm_submissionRegistrationCredentialOptions_submit',
  EgmSubmissionRegistrationCredentialOptionsSuccess = 'egm_submissionRegistrationCredentialOptions_success',
  EgmSubmissionRegistrationCredentialOptionsError = 'egm_submissionRegistrationCredentialOptions_error',
  EgmBrowserCredentialCreationStart = 'egm_browserCredentialCreation_start',
  EgmBrowserCredentialCreationSuccess = 'egm_browserCredentialCreation_success',
  EgmBrowserCredentialCreationError = 'egm_browserCredentialCreation_error',
  EgmSubmissionRegistrationCredentialSubmit = 'egm_submissionRegistrationCredential_submit',
  EgmSubmissionRegistrationCredentialSuccess = 'egm_submissionRegistrationCredential_success',
  EgmSubmissionRegistrationCredentialRejected = 'egm_submissionRegistrationCredential_rejected',
  EgmSubmissionRegistrationCredentialFailed = 'egm_submissionRegistrationCredential_failed',
}

// category
export const CATEGORY_SIGN_IN = 'signIn'
export const CATEGORY_TRANSFER = 'transfer'
export const CATEGORY_CORE = 'core'
export const CATEGORY_SETTINGS = 'settings'

// subcategory
export const SUBCATEGORY_SIGN_IN = 'signIn'
export const SUBCATEGORY_TRANSFER = 'transfer'
export const SUBCATEGORY_ADD_ACCOUNT = 'addAccount'
export const SUBCATEGORY_FUND_ACCOUNT = 'fundAccount'
export const SUBCATEGORY_HOME = 'home'
export const SUBCATEGORY_LIQUID_TREASURIES = 'liquid-treasuries'
export const SUBCATEGORY_APP_TOUR = 'app-tour'
export const SUBCATEGORY_ACCOUNT_INFO = 'account-info'
export const SUBCATEGORY_CARD_ACTIVATION = 'card-activation'
export const SUBCATEGORY_PASSKEY_RESET = 'passkey-reset'
export const SUBCATEGORY_PROFILE = 'profile'
export const SUBCATEGORY_SETTINGS = 'settings'
export const SUBCATEGORY_PASSKEY = 'passkey'
export const SUBCATEGORY_EXTERNAL_ACCOUNTS = 'external-accounts'
export const SUBCATEGORY_ACCOUNT_LINKING_PLAID = 'account-linking-plaid'

// sign in
export const SIGN_IN_INTENT = 'user_signIn_clicked'
export const SIGN_IN_SUCCESS = 'user_signIn_success'
export const SIGN_IN_FAILURE = 'user_signIn_fail'
export const SIGN_IN_ERROR = 'user_signIn_error' // FATAL API ERROR
export const SIGN_IN_VISIT = 'user_signIn_visit'
export const SIGN_IN_SINGLE_FACTOR = 'user_signIn_singleFactor'
export const USER_SIGN_IN_USERNAMELESS_INTENT = 'user_signInUsernameless_intent'
export const USER_SIGN_IN_EMAIL_INTENT = 'user_signInUEmail_intent'

// transfer
export const TRANSFER_STARTED = 'user_transfer_start'
export const TRANSFER_FUNDS_REQUEST_SUBMIT = 'user_transferFunds_click'
export const TRANSFER_FUNDS_REQUEST_SUCCESS = 'egm_transferFunds_success'
export const TRANSFER_FUNDS_REQUEST_FAILURE = 'egm_transferFunds_fail'
export const BANK_INVESTMENT_TRANSFER_REQUEST_SUBMIT = 'egm_bankInvestmentTransfer_submit'
export const BANK_INVESTMENT_TRANSFER_REQUEST_SUCCESS = 'egm_bankInvestmentTransfer_success'
export const BANK_INVESTMENT_TRANSFER_REQUEST_FAILURE = 'egm_bankInvestmentTransfer_fail'
export const INTERNAL_BANK_TRANSFER_REQUEST_SUBMIT = 'egm_internalBankTransfer_submit'
export const INTERNAL_BANK_TRANSFER_REQUEST_SUCCESS = 'egm_internalBankTransfer_success'
export const INTERNAL_BANK_TRANSFER_REQUEST_FAILURE = 'egm_internalBankTransfer_fail'

export const EXTERNAL_ACCOUNT_MANAGE_CLICK = 'user_manageExternalAccount_click'

// fund account
export const FUND_ACCOUNT_REQUEST_SUBMIT = 'egm_fundAccountTransfer_submit'
export const FUND_ACCOUNT_REQUEST_SUCCESS = 'egm_fundAccountTransfer_success'
export const FUND_ACCOUNT_REQUEST_FAILURE = 'egm_fundAccountTransfer_failure'

// activity
export const ACIVITY_WITHDRAW_FUNDS_SUCCESS = 'user_withdrawFunds_success' // can FE know that?
export const ACIVITY_DEBIT_CARD_USE = 'user_debitCard_use' // can FE know that?

// home
export const HOME_LIQUID_TREASURIES_LINK_CLICK = 'user_liquidTreasuriesLink_click'
export const HOME_SECURE_SAVINGS_LINK_CLICK = 'user_secureSavingsLink_click'
export const HOME_PERSONAL_PORTFOLIO_LINK_CLICK = 'user_personalPortolioLink_click'

// liquid treasuries
export const LIQUID_TREASURIES_PRODUCT_VISIT = 'user_liquidTreasuriesProduct_visit'

// app tour
export const TOUR_SERVE = 'client_appTour_serve'
export const TOUR_TAKE_QUICK_TOUR_CLICK = 'user_takeQuickTour_click'
export const TOUR_MAYBE_LATER_CLICK = 'user_maybeLater_click'
export const TOUR_DISMISS_CLICK = 'user_dismissTour_click'
export const TOUR_SCREEN_1_VIEW = 'user_tourScreen1_visit'
export const TOUR_SCREEN_2_VIEW = 'user_tourScreen2_visit'
export const TOUR_SCREEN_3_VIEW = 'user_tourScreen3_visit'
export const TOUR_SCREEN_4_VIEW = 'user_tourScreen4_visit'
export const TOUR_SCREEN_5_VIEW = 'user_tourScreen5_visit'
export const makeTourScreenVisitEvent = (step: number): string => `user_tourScreen${step.toString()}_visit`

// account info
export const ACCOUNT_INFO_CARD_LOCK_ENABLE = 'user_cardLock_enable'
export const ACCOUNT_INFO_REPORT_LOST_OR_STOLEN_CLICK = 'user_reportLostOrStolen_click'
export const ACCOUNT_INFO_ACTIVATE_PHYSICAL_CARD = 'user_activatePhysicalCard_click'

// setttings
export const SETTTINGS_SIGN_OUT_CLICK = 'user_signOut_click'

// passkey
export const PASSKEY_ADD = 'user_passkey_add'
export const PASSKEY_REMOVE = 'user_passkey_remove'

// external accounts
// Add external account events - instant
export const EXTERNAL_ACCOUNTS_REMOVE_ACCOUNT_CLICK = 'user_removeExternalAccount_click'
export const EXTERNAL_ACCOUNTS_REMOVE_ACCOUNT_FAIL = 'egm_removeExternalAccount_fail'
export const EXTERNAL_ACCOUNTS_LINK_INSTANTLY_CLICK = 'user_linkExternalAccountInstantly_click'
export const EXTERNAL_ACCOUNTS_LINK_INSTANTLY_FAIL = 'user_linkExternalAccountInstantly_fail'
export const EXTERNAL_ACCOUNTS_LINK_INSTANTLY_EVENT = 'user_linkExternalAccountInstantly_event'

export const EGM_PLAID_LINK_SUCCESS = 'egm_plaidLink_onSuccess'
export const EGM_PLAID_LINK_EXIT = 'egm_plaidLink_onExit'
export const EGM_PLAID_LINK_EVENT = 'egm_plaidLink_onEvent'

// Add external account events - manual
export const EXTERNAL_ACCOUNTS_LINK_MANUALLY_CLICK = 'user_linkExternalAccountManually_click'
export const EXTERNAL_ACCOUNTS_LINK_MANUALLY_FAIL = 'user_linkExternalAccountManually_fail'

export const ADD_EXTERNAL_ACCOUNT_INTENT = 'user_addExternalAccount_click'
export const ADD_EXTERNAL_ACCOUNT_SUBMIT = 'user_addExternalAccount_submit'
export const ADD_EXTERNAL_ACCOUNT_SUCCESS = 'egm_addExternalAccount_success'
export const ADD_EXTERNAL_ACCOUNT_FAILURE = 'egm_addExternalAccount_fail'

export const EGM_EXTERNAL_ACCOUNT_LINK_INSTANTLY_SUCCESS = 'egm_linkExternalAccountInstantly_success'
export const EGM_EXTERNAL_ACCOUNT_LINK_INSTANTLY_FAIL = 'egm_linkExternalAccountInstantly_fail'

// external accounts
export const MOBILE_NAVIGATION = 'mobile_navigation'

// Authentication Review
export const START_AUTH_CREDENTIAL_OPTIONS_REQUEST = 'device_requestAuthCredentialOptions_submit'
export const REQUEST_AUTH_CREDENTIAL_OPTIONS_SUCCESS = 'egm_requestAuthCredentialOptions_success'
export const REQUEST_AUTH_CREDENTIAL_OPTIONS_FAIL = 'egm_requestAuthCredentialOptions_fail'
export const REQUEST_AUTH_CREDENTIAL_OPTIONS_ERROR = 'egm_requestAuthCredentialOptions_error'
export const START_BUILDING_BROWSER_CREDENTIALS = 'device_browserAuthCredentialProvide_start'
export const BUILD_BROWSER_CREDENTIALS_SUCCESS = 'device_browserAuthCredentialProvide_success'
export const BUILD_BROWSER_CREDENTIALS_ERROR = 'device_browserAuthCredentialProvide_error'
export const AUTHENTICATE_WITH_CREDENTIALS_START = 'device_submissionAuthCredential_submit'

// Passkey Reset
export const USER_RECOVERY_PASSKEY_CREATE_SUCCESS_VISIT = 'user_recoveryPasskeyCreateSuccess_visit'
export const USER_RECOVERY_CREATE_NEW_PASSKEY_VISIT = 'user_createNewPasskey_visit'
export const USER_RECOVERY_DOCV_FRAUD_REVIEW_VISIT = 'user_docvFraudReview_visit'
export const USER_RECOVERY_MOBILE_PHONE_VERIFIED_PASSKEY_RESET_VISIT = 'user_mobilePhoneVerifiedPasskeyReset_visit'
export const USER_RECOVERY_DOC_VERIFY_YOUR_IDENTITY_VISIT = 'user_docvVerifyYourIdentity_visit'
export const USER_RECOVERY_IDENTITY_VERIFIED_VISIT = 'user_identityVerified_visit'
